import { render } from "./MultiSelector.vue?vue&type=template&id=5bbb20d7"
import script from "./MultiSelector.vue?vue&type=script&lang=js"
export * from "./MultiSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__